import { openWithAuthHandoff } from 'rhg-vue-common'

const DEFAULT_TRANSITION_DELAY_MS = 2000
const CONFIG_DYNAMIC_OVERRIDE_KEY = 'config-dynamic-keys-override'
const CONFIG_DYNAMIC_KEYS_PREFIX = 'config-dynamic-keys-'

const submitPostForm = (action, target, body = {}) => {
  const form = document.createElement('form')
  form.method = 'post'
  form.action = action
  form.target = target

  for (const [key, value] of Object.entries(body)) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = String(value)
    form.appendChild(input)
  }

  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

const valueOfDynamicConfig = key => {
  try {
    const override = JSON.parse(localStorage.getItem(CONFIG_DYNAMIC_OVERRIDE_KEY) || 'null')
    if (override && key in override) {
      return override[key]
    }

    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && k.startsWith(CONFIG_DYNAMIC_KEYS_PREFIX) && k !== CONFIG_DYNAMIC_OVERRIDE_KEY) {
        const cfg = JSON.parse(localStorage.getItem(k) || 'null')
        if (cfg && key in cfg) {
          return cfg[key]
        }
      }
    }
  } catch (e) {}
  return null
}

export const useCrossDomainNavigation = ({ onShowModal, onHideModal } = {}) => {
  let timer = null

  const trigger = (href, postBody, options = {}) => {
    if (!href) {
      return
    }

    const configSeconds = Number(valueOfDynamicConfig('lightbox.change.domain.time.in.seconds'))
    const delayMs =
      options.delayMs ?? (configSeconds > 0 ? configSeconds * 1000 : DEFAULT_TRANSITION_DELAY_MS)

    if (timer !== null) {
      clearTimeout(timer)
    } else if (typeof onShowModal === 'function') {
      onShowModal()
    }

    timer = setTimeout(() => {
      timer = null

      if (typeof onHideModal === 'function') {
        onHideModal()
      }

      if (!postBody) {
        openWithAuthHandoff(href)
        return
      }

      const windowName = `rdx-cd-${Date.now()}`

      const popup = window.open?.('about:blank', windowName) ?? null

      openWithAuthHandoff(href, { existingPopup: popup })

      submitPostForm(href, windowName, postBody)
    }, delayMs)
  }

  const cancel = () => {
    if (timer !== null) {
      clearTimeout(timer)
      timer = null
      if (typeof onHideModal === 'function') {
        onHideModal()
      }
    }
  }

  return { trigger, cancel }
}
